import React, { ReactNode } from 'react';
import { Box, Center, Flex, Text } from '@chakra-ui/react';
import { FaChevronRight } from 'react-icons/fa';
import { Link } from 'react-router-dom';

interface ConfigMenuItemProps {
  icon: ReactNode,
  label: string;
  description?: string;
  link?: string;
}

export const ConfigMenuItem = ({ icon, description, label, link }: ConfigMenuItemProps) => {
  return (
    <Link to={link || ''}>
      <Flex alignItems="center" _hover={{ background: 'neutral.100' }} padding="l" paddingX="xl" borderRadius="xl">
        <Center padding="l" fontSize="xxl" color="primary.800" borderRadius="full" borderWidth="1px"
                borderColor="primary.800">
          {icon}
        </Center>
        <Box flexGrow="1" width="30em" marginX="xl">
          <Text marginBottom="s" fontWeight="bold">{label}</Text>
          <Text fontSize="l" color="nutral.600">{description}</Text>
        </Box>
        <FaChevronRight />
      </Flex>
    </Link>
  );
};
